import { motion } from 'framer-motion'
import {
  Instagram,
  Linkedin,
  Facebook,
  Youtube,
  Twitter,
  ArrowUpRight
} from 'lucide-react'
import Logo from '../assets/logo.svg'

const products = [
  'Shilajit',
  'Ashwagandha',
  'Moringa',
  'Sea moss',
  'FADOGIA AGRESTIS',
  'Tongkat ali',
  'Probiotics',
  'Creatine gummies',
  'Tudca',
  'Psyllium husk',
  'Maca root',
  'Horny goat weed'
]

export default function Footer () {
  return (
    <footer className='relative bg-[#0F1C24] text-white overflow-hidden'>
      {/* Soft Brand Glow Effects */}
      <div className='absolute -top-24 -left-24 h-72 w-72 rounded-full blur-3xl opacity-20 bg-[#F47C20]' />
      <div className='absolute -bottom-24 -right-24 h-80 w-80 rounded-full blur-3xl opacity-20 bg-[#E83E6F]' />

      {/* Gradient Line */}
      <div className='h-[2px] w-full bg-gradient-to-r from-[#F47C20] via-[#C9A227] to-[#E83E6F]' />

      <div className='max-w-7xl mx-auto px-6 py-14 relative z-10'>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className='grid grid-cols-1 md:grid-cols-12 gap-10'
        >
          {/* Brand Section */}
          <div className='md:col-span-4'>
            <div className='flex items-center gap-3'>
              <img
                src={Logo}
                alt='Amera Exports Pvt. Ltd.'
                className='h-16  rounded-full shadow-sm border border-black/5'
              />
              <h2 className='text-lg font-semibold bg-gradient-to-r from-[#F47C20] to-[#E83E6F] bg-clip-text text-transparent'>
                Amera Exports Pvt. Ltd.
              </h2>
            </div>

            <p className='mt-4 text-sm text-white/75 leading-6'>
              Amera Export specializes in premium contract manufacturing,
              delivering high-quality dietary supplements to leading brands
              across the USA and Europe.
            </p>

            <motion.button
              whileHover={{ y: -3 }}
              whileTap={{ scale: 0.98 }}
              className='mt-5 px-5 py-2 text-sm font-semibold rounded-md
                         bg-gradient-to-r from-[#F47C20] to-[#E83E6F]
                         shadow-lg shadow-black/30'
            >
              Request Quote
            </motion.button>
          </div>

          {/* Products */}
          <div className='md:col-span-5'>
            <h3 className='text-sm font-semibold uppercase tracking-wider text-white/90'>
              Products
            </h3>

            <div className='mt-4 grid grid-cols-2 sm:grid-cols-3 gap-3'>
              {products.map(item => (
                <motion.a
                  key={item}
                  whileHover={{ x: 5 }}
                  href='#'
                  className='flex items-center gap-2 text-sm text-white/75 hover:text-white transition'
                >
                  <span className='h-1.5 w-1.5 rounded-full bg-gradient-to-r from-[#F47C20] to-[#E83E6F]' />
                  {item}
                </motion.a>
              ))}
            </div>
          </div>

          {/* Company Links + Social */}
          <div className='md:col-span-3'>
            <h3 className='text-sm font-semibold uppercase tracking-wider text-white/90'>
              About Us
            </h3>

            <div className='mt-4 space-y-3 text-sm text-white/75'>
              {['Manufacturing Process', 'Sustainability', 'Certificate'].map(
                link => (
                  <motion.a
                    key={link}
                    whileHover={{ x: 5 }}
                    href='#'
                    className='flex items-center gap-2 hover:text-white transition'
                  >
                    {link}
                    <ArrowUpRight size={14} />
                  </motion.a>
                )
              )}
            </div>

            <h3 className='mt-8 text-sm font-semibold uppercase tracking-wider text-white/90'>
              Follow Us On
            </h3>

            {/* <div className="mt-4 flex gap-3">
              {[Instagram, Linkedin, Facebook, Youtube, Twitter].map(
                (Icon, index) => (
                  <motion.a
                    key={index}
                    whileHover={{ y: -4 }}
                    href="#"
                    className="h-10 w-10 flex items-center justify-center
                               rounded-full bg-white/10 hover:bg-gradient-to-r
                               hover:from-[#F47C20] hover:to-[#E83E6F]
                               transition duration-300"
                  >
                    <Icon size={18} />
                  </motion.a>
                )
              )}
            </div> */}
            <div className='mt-4 flex flex-wrap gap-3'>
              {/* Instagram */}
              <motion.a
                whileHover={{ y: -4 }}
                whileTap={{ scale: 0.95 }}
                href='https://www.instagram.com/theameragroup'
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Instagram'
                className='h-10 w-10 flex items-center justify-center
               rounded-full bg-white/10 hover:bg-gradient-to-r
               hover:from-[#F47C20] hover:to-[#E83E6F]
               transition duration-300 shadow-md'
              >
                <Instagram size={18} />
              </motion.a>

              {/* Facebook */}
              <motion.a
                whileHover={{ y: -4 }}
                whileTap={{ scale: 0.95 }}
                href='https://www.facebook.com/TheAmeraGroup'
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Facebook'
                className='h-10 w-10 flex items-center justify-center
               rounded-full bg-white/10 hover:bg-gradient-to-r
               hover:from-[#F47C20] hover:to-[#E83E6F]
               transition duration-300 shadow-md'
              >
                <Facebook size={18} />
              </motion.a>

              {/* LinkedIn */}
              <motion.a
                whileHover={{ y: -4 }}
                whileTap={{ scale: 0.95 }}
                href='https://www.linkedin.com/company/theameragroup'
                target='_blank'
                rel='noopener noreferrer'
                aria-label='LinkedIn'
                className='h-10 w-10 flex items-center justify-center
               rounded-full bg-white/10 hover:bg-gradient-to-r
               hover:from-[#F47C20] hover:to-[#E83E6F]
               transition duration-300 shadow-md'
              >
                <Linkedin size={18} />
              </motion.a>

              {/* Twitter / X */}
              <motion.a
                whileHover={{ y: -4 }}
                whileTap={{ scale: 0.95 }}
                href='https://twitter.com/TheAmeraGroup'
                target='_blank'
                rel='noopener noreferrer'
                aria-label='Twitter'
                className='h-10 w-10 flex items-center justify-center
               rounded-full bg-white/10 hover:bg-gradient-to-r
               hover:from-[#F47C20] hover:to-[#E83E6F]
               transition duration-300 shadow-md'
              >
                <Twitter size={18} />
              </motion.a>

              {/* YouTube */}
              <motion.a
                whileHover={{ y: -4 }}
                whileTap={{ scale: 0.95 }}
                href='https://m.youtube.com/channel/UCP_kNiDKMImiPLr2mL7dg-A/featured'
                target='_blank'
                rel='noopener noreferrer'
                aria-label='YouTube'
                className='h-10 w-10 flex items-center justify-center
               rounded-full bg-white/10 hover:bg-gradient-to-r
               hover:from-[#F47C20] hover:to-[#E83E6F]
               transition duration-300 shadow-md'
              >
                <Youtube size={18} />
              </motion.a>
            </div>
          </div>
        </motion.div>

        {/* Bottom Section */}
        <div className='mt-12 border-t border-white/10 pt-6 flex flex-col sm:flex-row justify-between items-center text-xs text-white/60 gap-3'>
          <p>
            © {new Date().getFullYear()} Amera Exports Pvt. Ltd. All rights
            reserved.
          </p>
          <div className='flex gap-4'>
            <a href='#' className='hover:text-white transition'>
              Privacy Policy
            </a>
            <a href='#' className='hover:text-white transition'>
              Terms & Conditions
            </a>
          </div>
        </div>
      </div>
    </footer>
  )
}
